/* mobile-video-autoplay.js
   Forces muted + inline playback so slideshow videos autoplay on iOS and Android.
   Added 21 Aug 2026. Safe to delete if the theme is updated to handle this itself. */
(function () {
  function fixVideo(v) {
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    if (v.getAttribute('autoplay') === null) return;
    if (v.closest('.function-paused')) return;
    if (!v.paused) return;
    var p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
  }

  function fixAll() {
    var videos = document.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      fixVideo(videos[i]);
    }
  }

  function ready() {
    fixAll();
    if (window.MutationObserver && document.body) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          fixAll();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) fixAll();
    });
    ['touchstart', 'click', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, fixAll, { once: true, passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
